import { ModelBase } from '../abstract/model-base.model';

export class TgcDeclarationFieldInvoice extends ModelBase {

    static override CLASS_NAME: string = 'TgcDeclarationFieldInvoice';

    private _amount!: number;
    private _invoiceType!: string;
    private _label!: string;
    private _presignedUrl!: string;

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get invoiceType(): string {
        return this._invoiceType;
    }

    public set invoiceType(value: any) {
        this._setValue('_invoiceType', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get presignedUrl(): string {
        return this._presignedUrl;
    }

    public set presignedUrl(value: any) {
        this._setValue('_presignedUrl', value, 'string');
    }
}
